export const SHOPIFY_PLANS = {
    PLUS: 'shopify_plus',
    AFFILIATE: 'affiliate',
    PARTNER_TEST: 'partner_test'
}
